module.exports = "/v2/pages/dashboard/dist/7fa3d3390d8391daf5c5edded251b6fd.svg";